// @flow
import React from 'react';
import * as css from './WatchSvg.module.css';

type PropsType = {
  className: string,
};

const SamsungWatchSvg = ({ className }: PropsType) => {
  return (
    <svg width="97" height="158" className={`${className} ${css.svgIcon}`} xmlns="http://www.w3.org/2000/svg">
      <title>Galaxy Watch</title>
      <g transform="translate(2 2)" strokeWidth="4.375" fill="none" fillRule="evenodd">
        <ellipse stroke="#000D1E" cx="46.5" cy="77.131" rx="46.061" ry="45.938" />
        <path
          d="M19.302 115.194v26.88c.005 6.415 5.218 11.615 11.651 11.62h31.094c6.433-.005 11.646-5.205 11.651-11.62v-26.88M73.698 39.069v-26.88c0-3.082-1.227-6.038-3.412-8.217A11.667 11.667 0 0 0 62.046.57H30.954c-3.09 0-6.053 1.224-8.239 3.403a11.604 11.604 0 0 0-3.412 8.217v26.88"
          stroke="#000D1E"
        />
        <path stroke="#000" d="M26.742 95.944l19.31-18.375-.877-35.875" />
      </g>
    </svg>
  );
};

export default SamsungWatchSvg;
